"use client";

import Link from "next/link";
import { useAppFeatureFlag } from "@/components/feature-flags/feature-flags-provider";
import {
  SITE_CONTROL_NAME,
  SITE_CONTROL_PRICE_HEADLINE,
} from "@/lib/site-control-copy";

/**
 * Site Control footnote for the shared marketing PricingFeatureTable
 * (components/marketing/blocks/pricing-feature-table.tsx) — surfaced beneath
 * the Starter/Pro/Business columns on /features, every /features/* page,
 * every /for/* trade page and every /use-cases/* page.
 *
 * Self-gating on the DB-backed `site_control` flag (read from the marketing
 * layout's AppFeatureFlagsProvider): renders nothing when the flag is off, so
 * it appears and disappears in lockstep with the rest of the Site Control
 * surface. Site Control is quote-led and deliberately stays OUT of the
 * self-serve column set — this note is the principal-contractor pointer to the
 * /site-control landing page.
 */
export function SiteControlPricingNote() {
  const enabled = useAppFeatureFlag("site_control");
  if (!enabled) return null;

  return (
    <p
      data-testid="site-control-note"
      className="mx-auto mt-6 max-w-3xl text-center text-xs leading-snug text-muted sm:text-sm"
    >
      Running live sites with subcontractors?{" "}
      <Link
        href="/site-control"
        className="font-semibold text-brand-700 hover:text-accent-dark"
      >
        {SITE_CONTROL_NAME}
      </Link>{" "}
      is the per-site enterprise tier above Business — entrance QR sign-in, CSCS
      checks, induction gating, live attendance and audit-grade exports.{" "}
      {SITE_CONTROL_PRICE_HEADLINE}.
    </p>
  );
}
